import { authAxios as axios } from "api-generate-types/src/axios";
import { config } from "../../../../../../../config";

export function useSubmitPurchase(addOns: string[]) {
  return () => axios.post(`${config.billingApiUrl}addons/purchase`, { addOns });
}
